export type RemovalReason =
  | "now_registered"
  | "no_longer_using"
  | "duplicate"
  | "wrong_details"
  | "other";

export const REMOVAL_REASON_OPTIONS: { value: RemovalReason; label: string }[] =
  [
    { value: "now_registered", label: "Now registered on platform" },
    { value: "no_longer_using", label: "No longer using this lab" },
    { value: "duplicate", label: "Duplicate / added by mistake" },
    { value: "wrong_details", label: "Wrong details" },
    { value: "other", label: "Other" },
  ];

export const REMOVAL_REASON_LABELS: Record<RemovalReason, string> =
  Object.fromEntries(
    REMOVAL_REASON_OPTIONS.map((o) => [o.value, o.label])
  ) as Record<RemovalReason, string>;

export type Partner = {
  id: string;
  labId: string | null;
  name: string;
  officialName?: string;
  contactName?: string;
  email?: string;
  phone?: string;
  address?: string;
  isShadow?: boolean;
  status?: string;
  linkSource?: string;
  canSendOrders?: boolean;
  canTrackOrders?: boolean;
  createdAt?: string;
  removedAt?: string;
  removalReason?: RemovalReason | string;
  removalNote?: string;
};

export type DirectoryLab = {
  id: string;
  labId: string;
  name: string;
  officialName?: string;
  email?: string;
  phone?: string;
  address?: string;
};

export type LocalLabForm = {
  labName: string;
  contactName: string;
  phone: string;
  email: string;
  address: string;
};

export const emptyLocalLabForm = (): LocalLabForm => ({
  labName: "",
  contactName: "",
  phone: "",
  email: "",
  address: "",
});

export type DetailModalMode =
  | "view-partner"
  | "view-directory"
  | "edit-personal";

export function formatRemovedDate(iso?: string): string {
  if (!iso) return "—";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}
